const INDEX_ITEMS = [
  {
    id: 1,
    title: '热血少年漫',
    icon: 'ri-fire-line',
    color: 'primary',
    desc: '战斗、热血、友情、成长',
    count: '3,200+',
  },
  {
    id: 2,
    title: '恋爱甜宠漫',
    icon: 'ri-heart-line',
    color: 'accent',
    desc: '甜蜜、治愈、心动、浪漫',
    count: '2,800+',
  },
  {
    id: 3,
    title: '奇幻冒险漫',
    icon: 'ri-compass-3-line',
    color: 'secondary',
    desc: '异世界、魔法、冒险、传奇',
    count: '2,400+',
  },
  {
    id: 4,
    title: '悬疑推理漫',
    icon: 'ri-search-eye-line',
    color: 'primary',
    desc: '推理、烧脑、反转、惊悚',
    count: '1,600+',
  },
  {
    id: 5,
    title: '搞笑日常漫',
    icon: 'ri-emotion-laugh-line',
    color: 'accent',
    desc: '沙雕、轻松、欢乐、治愈',
    count: '2,100+',
  },
  {
    id: 6,
    title: '玄幻修仙漫',
    icon: 'ri-moon-line',
    color: 'secondary',
    desc: '修仙、玄幻、境界、飞升',
    count: '3,500+',
  },
  {
    id: 7,
    title: '国漫精选',
    icon: 'ri-flag-2-line',
    color: 'primary',
    desc: '原创、国风、崛起、精品',
    count: '1,800+',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            分类索引
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            按漫画类型快速查找，发现属于你的阅读世界
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {INDEX_ITEMS.slice(0, 4).map((item) => (
            <div
              key={item.id}
              className="group rounded-xl p-5 bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg mb-3 ${
                item.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                item.color === 'accent' ? 'bg-accent-100 text-accent-600' :
                'bg-secondary-100 text-secondary-600'
              } group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-600 mb-2">{item.desc}</p>
              <span className="text-xs text-foreground-500">{item.count} 部作品</span>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {INDEX_ITEMS.slice(4).map((item) => (
            <div
              key={item.id}
              className="group rounded-xl p-5 bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg mb-3 ${
                item.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                item.color === 'accent' ? 'bg-accent-100 text-accent-600' :
                'bg-secondary-100 text-secondary-600'
              } group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-600 mb-2">{item.desc}</p>
              <span className="text-xs text-foreground-500">{item.count} 部作品</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}